
import { fork, take, call, put, all } from 'redux-saga/effects'

import * as types from '../types'
import * as actions from '../actions'
import { getFengkongData } from '@/utils'
import { listBtTasks, receiveBtTask, getWaterfallsFlowForH5, isBtUser, currentTime } from '@/network'
import Toast from '@/components/comToast' 
export function* listBaseReq() {
    while (true) {
        const { data } = yield take(types.LIST_BASE_REQ);
        const { pageId } = data;
        
        try {
            const v = yield call(getWaterfallsFlowForH5, { pageId })
            if (v) {
                yield put(actions.listBaseHandle(v.resultList));
            } else {
                //yield put(actions.receiveConsumeRecord(pageNum, []))
            }
        } catch (e) {
            if(e?.error) {
                Toast.showMessage('活动太火爆了');
            }
        } finally {
        }

    }
}

export function* listReq() {
    while (true) {
        const { data } = yield take(types.LIST_REQ);
        const { channelCode, sortType, pageNo } = data;
        
        try {
            const {v, timer} = yield all({
                v: call(listBtTasks, { channelCode, sortType, pageBean: {pageNo, pageSize: 10} }),
                timer: call(currentTime, {})
              })
            //const v = yield call(listBtTasks, { channelCode, sortType, pageBean: {pageNo, pageSize: 10} })
            if (v?.value && v.success) {
                yield put(actions.listHandle({list: v.value, pageBean: v.pageBean, timer: timer.value}));
            } else {
                Toast.showMessage(v.resultMsg);
                //yield put(actions.receiveConsumeRecord(pageNum, []))
            }
        } catch (e) {
            if(e?.error) {
                Toast.showMessage('活动太火爆了');
            }
        } finally {
        }

    }
}
export function* taskReq() {
    while (true) {
        const { data } = yield take(types.TASK_REQ);
        const { channelCode, taskCode } = data;
        try {
            const v = yield call(receiveBtTask, { channelCode, taskCode, deviceInfo: getFengkongData() })
            if (v?.value && v.success && v.resultCode === '0000') {
                yield put(actions.taskHandle({
                    value: v.value,
                    channelCode,
                    taskCode
                }));
                //yield put(actions.listReq({channelCode, sortType: 1}));
            } else if(v.resultCode === 'A0025') {
                Toast.showMessage('该活动为京东PLUS会员专享');
            }else {
                Toast.showMessage(v.resultMsg || '活动太火爆了');
            }
        } catch (e) {
            if(e?.error?.resultCode === 'A0025') {
                Toast.showMessage('该活动为京东PLUS会员专享');
            }else {
                Toast.showMessage(e.error.resultMsg || '活动太火爆了');
            }
        } finally {
        }

    }
}

export default function* root() {
    yield fork(listBaseReq);
    yield fork(listReq)
    yield fork(taskReq)
}